module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-stone-path.e4ed4832.png";